import { intersection, isEqual, without } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { constants } from '../../shared/constants';
import CustomWidget from '../Custom/CustomWidget';
import HirarchyDDL from '../Custom/HirarchyDDL';
import ReportTopBarWidget from '../Custom/ReportTopBarWidget';
import PermissibleLoading from '../EnergyEfficiencyApp/EEReports/PermissibleLoading';
import TabPowerQuality from '../EnergyEfficiencyApp/PowerQualityTab';
import FeederCurves from '../FaultApp/Report/FeederCurves';
import TabBattery from './TabBattery';
import TabDemand from './TabDemand';
import TabEnergy from './TabEnergy';
import TabFaultTrends from './TabFaultTrends';
import TabForecast from './TabForecast';
import TabLiveReadings from './TabLiveReadings';
import TabReliability from './TabReliability';
import LowCarbonAnalyticsTab from '../LowCarbonApp/LowCarbonAnalyticsTab';
import { AccessContext } from '../../contexts/AccessProvider';
import { checkTabAccessForAnalytics } from '../../utils/helper';

const { TABS, APPS, ANALYTICSTABS, ANALYTICS_APPS } = constants.core;

const ReportsBody = ({ hirarchy, appName }) => {
  const contextData = useContext(AccessContext);
  const appWiseAnalyticsTabs = ANALYTICSTABS[appName];

  const [selectedTab, setSelectedTab] = useState('');

  const [tabs, setTabs] = useState([]); // State to store the tabs

  useEffect(() => {
    const fetchTabs = async () => {
      const { tabAccessList } = await checkTabAccessForAnalytics(
        contextData.pageAccess,
        ANALYTICS_APPS[appName],
        'Analytics',
        appWiseAnalyticsTabs
      );
      const resolvedTabAccessList = await tabAccessList;

      const tabsToView = intersection(resolvedTabAccessList, hirarchy.tabsList);
      const tabsToVisible =
        (await hirarchy.type.label) === 'Asset'
          ? tabsToView
          : without([...tabsToView], 'Quality Check');
      setTabs(tabsToVisible);
      if (tabsToVisible) {
        setSelectedTab(tabsToVisible[0]);
      }
    };

    fetchTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextData.pageAccess, hirarchy.tabsList, hirarchy.type, appName]);

  const isValidate = useCallback(
    (widgetName, _appName) =>
      isEqual(selectedTab, widgetName) && isEqual(_appName, appName),
    [selectedTab, appName]
  );

  if (isEqual(appName, constants.core.APPS.LOWCARBON)) {
    return (
      <>
        <div className="box">
          <LowCarbonAnalyticsTab deviceId={hirarchy.level.value} />
        </div>
      </>
    );
  }

  return (
    <>
      <div style={{ marginLeft: '15px' }}>
        <HirarchyDDL appName={appName} />
      </div>

      {hirarchy.type.value && hirarchy.level.value && tabs.length > 0 && (
        <Col lg={12}>
          <div className="box">
            <ReportTopBarWidget
              rrReportsTab={tabs}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />

            {/* ENERGY */}
            {isValidate(
              TABS.ENERGY_EFFICIENCY.ENERGY,
              APPS.ENERGY_EFFICIENCY
            ) && <TabEnergy hirarchy={hirarchy} />}
            {isValidate(
              TABS.ENERGY_EFFICIENCY.RELIABILITY,
              APPS.ENERGY_EFFICIENCY
            ) && <TabReliability hirarchy={hirarchy} />}
            {isValidate(
              TABS.ENERGY_EFFICIENCY.DEMAND,
              APPS.ENERGY_EFFICIENCY
            ) && <TabDemand hirarchy={hirarchy} />}
            {isValidate(
              TABS.ENERGY_EFFICIENCY.FORECAST,
              APPS.ENERGY_EFFICIENCY
            ) && <TabForecast hirarchy={hirarchy} />}
            {isValidate(
              TABS.ENERGY_EFFICIENCY.QUALITY_CHECK,
              APPS.ENERGY_EFFICIENCY
            ) && <TabPowerQuality deviceId={hirarchy.level.value} />}

            {/* FAULT */}
            {isValidate(TABS.FAULT.FAULT_TRENDS, APPS.FAULT) && (
              <TabFaultTrends hirarchy={hirarchy} />
            )}
            {isValidate(TABS.FAULT.FEEDER_CURVES, APPS.FAULT) && (
              <FeederCurves
                obj={{ type: hirarchy.type.label, id: hirarchy.level.value }}
              />
            )}

            {/* ASSET */}
            {isValidate(TABS.ASSET.LIVE_READINGS, APPS.ASSET) &&
              hirarchy.type.label === 'Asset' && (
                <TabLiveReadings hirarchy={hirarchy} />
              )}

            {isValidate(TABS.ASSET.PERMISSIBLE_LOADING, APPS.ASSET) &&
              hirarchy.type.label === 'Asset' && (
                <CustomWidget
                  size={12}
                  id={'chrtPermisible'}
                  title={'Permissible Loading'}
                >
                  <PermissibleLoading id={hirarchy.level.value} />
                </CustomWidget>
              )}
            {isValidate(TABS.ASSET.BATTERY, APPS.ASSET) && (
              <TabBattery hirarchy={hirarchy} />
            )}
          </div>
        </Col>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  hirarchy: state.HirarchyReducer.hirarchy,
});

export default connect(mapStateToProps, null)(ReportsBody);
